var map = {
	"./app.png": 11633,
	"./controller.png": 93510,
	"./data.png": 73130,
	"./logs.png": 35027,
	"./market.png": 94494,
	"./my.png": 31752,
	"./personnel.png": 32024,
	"./right-settings.png": 98938,
	"./smart.png": 1327,
	"./statistics.png": 86347,
	"./system-settings.png": 851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36512;